module.exports = __webpack_public_path__ + "img/cq.1e75f6ba.png";